import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Tooltip, Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {uid} from "react-uid";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Utils/lib";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {useResponsiveStyles} from "../../../../Hooks/useResponsiveStyles";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";
import IconCustom from "../../../../Utils/IconCustom/IconCustom";
import clsx from "clsx";

const ButtonScreenComponent = (props) => {
    const {
        element, loadingData, doActions, actionsContext,
        screenName, delete: deleteAction, cancel, isTableCell
    } = props;
    const [isReq, setIsReq] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [actions, setActions] = useState([]);
    const [fileMask, setFileMask] = useState([]);
    const [fileType, setFileType] = useState(null);
    const [fileProps, setFileProps] = useState({refId: null, refEntity: null, sharedWith: null});
    const [errorMessage, setErrorMessage] = useState(null);
    //will use for clear upload field from js executor
    const [uploadInputId, setUploadInputId] = useState(null)

    const {styles: stls, properties, events = [{}]} = element;
    const globalValues = useSelector(state => state.jsonScreen.globalValues)
    const isActive = checkHidden({...globalValues, ...actionsContext}, properties.activeState, screenName)
    const currentResolution = useCurrentResolution();
    const styles = useResponsiveStyles(stls, currentResolution, isActive);
    const history = useHistory();
    const buttonStyles = {
        width: styles.width,
        height: styles.height,
        margin: styles.margin,
        textAlign: styles.textAlign,
        fontSize: styles.fontSize,
        fontWeight: styles.fontWeight,
        textDecoration: styles.textDecoration,
        color: styles.color,
        background: styles.background,
        variant: styles.variant,
        borderColor: styles.borderColor,
        borderRadius: styles.borderRadius,
        padding: styles.padding
    };
    const isDisabled = checkHidden({...globalValues, ...actionsContext}, properties.disabledCondition, screenName);
    const isHidden = checkHidden({...globalValues, ...actionsContext}, properties.hideCondition, screenName);

    useEffect(() => {
        const actions = events[0] ? events[0].actions : undefined;
        let fileMask = [];
        let fileType = 'system';
        let additionalFileProps = {refId: null, refEntity: null}
        if (actions) {
            //used for submit form (handle required or patterns of html5 native field properties)
            let isRequest = properties.validateFields || actions.some((item) => item ? checkForActionType(item.type) : false);

            //used for selecting file from user's local files
            let isUploadAction = actions.some((item) => item ? item.type === 'uploadFile' : false);

            //check and apply file mask
            if (isUploadAction) {
                actions.forEach(action => {
                    if (action.type === 'uploadFile') {
                        fileMask = action.fileMask;
                        fileType = action.fileType;
                        additionalFileProps.refEntity = action.refEntity;
                        additionalFileProps.refId = action.refId;
                        additionalFileProps.sharedWith = action.sharedWith;
                        additionalFileProps.maxSize = action.maxSize;
                        setUploadInputId(action.setToVar ? action.setToVar : action.inputId);
                    }
                })
            }
            setFileProps(additionalFileProps)
            setIsReq(isRequest)
            setIsUpload(isUploadAction)
            setActions(actions)
            setFileMask(fileMask)
            setFileType(fileType)
        }
    }, [])

    const onKeyDownButton = (event) => {
        if (event.keyCode === 27) {
            history.goBack();
        }
    };

    const onClickEvent = async (e, actions, isReq) => {
        e.stopPropagation();
        if (isReq) {
            props.submitFnRef.current = async () => {
                doActions(actions, {...actionsContext}, e)
            }
        } else {
            doActions(actions, {...actionsContext}, e);
        }
    };

    const fileUpload = (e) => {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];

            if (fileProps.maxSize !== undefined) {
                if (file.size > fileProps.maxSize * 1000000) {
                    setErrorMessage(`File size is larger than ${fileProps.maxSize} mb`)
                    return
                }
            }

            //clear error message
            if (errorMessage) setErrorMessage(null);

            let objUrl = URL.createObjectURL(file);
            const sharedWith = getParamsFromString(fileProps.sharedWith, {...globalValues, ...actionsContext}, screenName)
            let fileInfo = {
                name: file.name,
                type: fileType ? getParamsFromString(fileType, {...globalValues, ...actionsContext}, screenName) : 'system',
                refId: getParamsFromString(fileProps.refId, {...globalValues, ...actionsContext}, screenName),
                refEntity: getParamsFromString(fileProps.refEntity, {...globalValues, ...actionsContext}, screenName),
                sharedWith: sharedWith ? [sharedWith] : null,
                content: objUrl
            };
            let newActions = actions.map(action => {
                if (action.type === 'uploadFile') {
                    return {...action, param: [{value: [fileInfo]}]}
                }
                return action
            });
            doActions(newActions, actionsContext);
        }
    };

    return (
        <div
            className={clsx('sb-button-container', styles.className)}
            style={{
                // padding: properties.type === 'iconButton' ? 0 : styles.padding,
                width: buttonStyles.width || 'auto',
                height: buttonStyles.height || 'auto',
                border: isTableCell ? '0px solid transparent' : '2px solid transparent',
                display: isHidden ? 'none' : 'block',
                margin: buttonStyles.margin
            }}>
            {isUpload ? (
                    <UploadButton
                        fileMask={fileMask}
                        fileUpload={fileUpload}
                        actions={actions}
                        properties={properties}
                        styles={styles}
                        buttonStyles={buttonStyles}
                        loadingData={loadingData}
                        screenName={screenName}
                        globalValues={globalValues}
                        isDisabled={isDisabled}
                        uploadInputId={uploadInputId}
                        errorMessage={errorMessage}
                    />) :
                properties.type === 'default' || properties.type === undefined ? (
                    <DefaultButton
                        isReq={isReq}
                        properties={properties}
                        loadingData={loadingData}
                        onClickEvent={onClickEvent}
                        onKeyDownButton={onKeyDownButton}
                        buttonStyles={buttonStyles}
                        actions={actions}
                        screenName={screenName}
                        globalValues={{...globalValues, ...actionsContext}}
                        isDisabled={isDisabled}
                    />
                ) : (
                    <IconButtonCustom
                        styles={styles}
                        buttonStyles={buttonStyles}
                        isReq={isReq}
                        properties={properties}
                        cancel={cancel}
                        deleteAction={deleteAction}
                        loadingData={loadingData}
                        doActions={doActions}
                        onClickEvent={onClickEvent}
                        actions={actions}
                        globalValues={{...globalValues, ...actionsContext}}
                        screenName={screenName}
                        isDisabled={isDisabled}
                    />
                )}
        </div>
    )

}
export default JsonScreenHoc(ButtonScreenComponent);
ButtonScreenComponent.propTypes = {
    element: PropTypes.object,
    history: PropTypes.object,
    doActions: PropTypes.func,
    actionsContext: PropTypes.object,
    loadingData: PropTypes.bool,
    delete: PropTypes.func,
    cancel: PropTypes.func,
    screenName: PropTypes.string,
    globalValues: PropTypes.object,
    isTableCell: PropTypes.bool
}

const DefaultButton = (props) => {
    const {
        isReq, properties,
        loadingData, onClickEvent,
        actions, onKeyDownButton, buttonStyles,
        globalValues, screenName, isDisabled
    } = props;
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage)
    const multiLanguageTooltip = multiLanguageValue(properties.tooltip, userLanguage)
    const btnLabel = getParamsFromString(multiLanguageLabel, globalValues, screenName);
    const startIcon = getParamsFromString(properties.startIcon, globalValues, screenName);
    const endIcon = getParamsFromString(properties.endIcon, globalValues, screenName);

    //styles
    const defaultBackgrounds = ['primary', 'secondary', 'default'];
    const isOldBackground = defaultBackgrounds.indexOf(buttonStyles.color) !== -1 && !buttonStyles.background;
    const isDefaultBackground = defaultBackgrounds.indexOf(buttonStyles.background) !== -1;
    const btnStyles = buttonStyles.variant === 'contained' ? {
        ...buttonStyles,
        width: buttonStyles.width ? '100%' : 'auto',
        //  minWidth: buttonStyles.width ? buttonStyles.width : 'auto',
        background: isDisabled ? null : isOldBackground ? '' : !isDefaultBackground ? buttonStyles.background : '',
        color: isDisabled ? null : buttonStyles.color,

    } : buttonStyles.variant === 'outlined' ? {
        ...buttonStyles,
        background: 'transparent',
        width: buttonStyles.width ? '100%' : 'auto',
        // minWidth: buttonStyles.width ? buttonStyles.width : 'auto',
        borderColor: isDisabled ? null : isOldBackground ? '' : !isDefaultBackground ? buttonStyles.background : '',
        color: isDisabled ? null : buttonStyles.color,
    } : {
        ...buttonStyles,
        width: buttonStyles.width ? '100%' : 'auto',
        //   minWidth: buttonStyles.width ? buttonStyles.width : 'auto',
        // background: isDisabled ? null : isOldBackground ? '' : !isDefaultBackground ? buttonStyles.background : '',
        color: isDisabled ? null : buttonStyles.color,
    }


    return (
        <Tooltip title={multiLanguageTooltip}>
            <Button variant={buttonStyles.variant}
                    className={'sb-button-default'}
                    size={"small"}
                    endIcon={endIcon ? <IconCustom style={{fontSize: '18px'}} iconType={endIcon.iconType}>{endIcon.icon ? endIcon.icon : endIcon}</IconCustom> : false}
                    startIcon={startIcon ? <IconCustom style={{fontSize: '18px'}} iconType={startIcon.iconType}>{startIcon.icon ? startIcon.icon : startIcon}</IconCustom> : false}
                    type={isReq === true ? 'submit' : 'button'}
                    disabled={isDisabled ? isDisabled : loadingData}
                    form={screenName + '_screenForm'}
                    color={isDisabled ? 'default' : isOldBackground ? buttonStyles.color : buttonStyles.background}
                    onClick={(e) => onClickEvent(e, actions, isReq)}
                    onKeyDown={(e) => onKeyDownButton(e)}
                    style={btnStyles}
            >{btnLabel}</Button>
        </Tooltip>
    )
};
const IconButtonCustom = (props) => {
    const {
        buttonStyles,
        properties,
        actions,
        isReq,
        onClickEvent,
        globalValues,
        screenName,
        isDisabled,
        loadingData
    } = props;
    const [icon, setIcon] = useState('');
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageTooltip = multiLanguageValue(properties.tooltip, userLanguage)
    useEffect(() => {
        setIcon(getParamsFromString(properties.icon, globalValues, screenName))
    }, [properties.icon, JSON.stringify(globalValues)]);
    const defaultBackgrounds = ['primary', 'secondary', 'default'];
    const isOldBackground = defaultBackgrounds.indexOf(buttonStyles.color) !== -1 && !buttonStyles.background;
    const isDefaultBackground = defaultBackgrounds.indexOf(buttonStyles.background) !== -1;
    return (
        <Tooltip title={multiLanguageTooltip && (
            <span
                style={{whiteSpace: "pre-wrap", fontSize: 14}}> {getParamsFromString(multiLanguageTooltip, globalValues, screenName)} </span>
        )}>
            <IconButton variant={buttonStyles.variant}
                        className={'sb-button-icon'}
                        type={isReq === true ? 'submit' : 'button'}
                        disabled={isDisabled ? isDisabled : loadingData}
                        form={screenName + '_screenForm'}
                        color={isDefaultBackground ? buttonStyles.background : isOldBackground ? buttonStyles.color : ''}
                        onClick={(e) => onClickEvent(e, actions, isReq)}
                        style={{
                            ...buttonStyles.border,
                            opacity: isDisabled ? 0.5 : 1,
                            borderColor: buttonStyles.borderColor,
                            borderRadius: buttonStyles.borderRadius,
                            fontSize: buttonStyles.fontSize || '24px',
                            width: buttonStyles.width,
                            height: buttonStyles.height,
                            margin: buttonStyles.margin,
                            padding: buttonStyles.padding ? buttonStyles.padding : 3,
                            textAlign: buttonStyles.textAlign,
                            color: isDefaultBackground ? '' : buttonStyles.background
                        }}
            >
                <IconCustom
                    style={{fontSize: buttonStyles.fontSize || '24px'}}
                    iconType={properties.iconType}
                >{icon}</IconCustom>
            </IconButton>
        </Tooltip>
    )
};
const UploadButton = (props) => {
    const {
        fileMask, fileUpload, actions, styles,
        properties, loadingData, buttonStyles, isDisabled,
        screenName, globalValues, uploadInputId, errorMessage
    } = props;
    const uniqueId = uploadInputId || uid(properties);
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageTooltip = multiLanguageValue(properties.tooltip, userLanguage)
    const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage)
    const startIcon = getParamsFromString(properties.startIcon, globalValues, screenName);
    const endIcon = getParamsFromString(properties.endIcon, globalValues, screenName);
    const defaultBackgrounds = ['primary', 'secondary', 'default'];
    const isOldBackground = defaultBackgrounds.indexOf(buttonStyles.color) !== -1 && !buttonStyles.background;
    const isDefaultBackground = defaultBackgrounds.indexOf(buttonStyles.background) !== -1;
    const btnStyles = buttonStyles.variant === 'contained' ? {
        ...buttonStyles,
        width: buttonStyles.width ? '100%' : 'auto',
        //  minWidth: buttonStyles.width ? buttonStyles.width : 'auto',
        background: isDisabled ? null : isOldBackground ? '' : !isDefaultBackground ? buttonStyles.background : '',
        color: isDisabled ? null : buttonStyles.color,

    } : buttonStyles.variant === 'outlined' ? {
        ...buttonStyles,
        background: 'transparent',
        width: buttonStyles.width ? '100%' : 'auto',
        // minWidth: buttonStyles.width ? buttonStyles.width : 'auto',
        borderColor: isDisabled ? null : isOldBackground ? '' : !isDefaultBackground ? buttonStyles.background : '',
        color: isDisabled ? null : buttonStyles.color,
    } : {
        ...buttonStyles,
        width: buttonStyles.width ? '100%' : 'auto',
        //   minWidth: buttonStyles.width ? buttonStyles.width : 'auto',
        // background: isDisabled ? null : isOldBackground ? '' : !isDefaultBackground ? buttonStyles.background : '',
        color: isDisabled ? null : buttonStyles.color,
    }
    return (
        <Tooltip title={multiLanguageTooltip}>
        <span>
            <input id={uniqueId}
                   type="file"
                   style={{display: "none"}}
                   accept={fileMask}
                   disabled={isDisabled ? isDisabled : loadingData}
                   onChange={(e) => fileUpload(e, actions)}/>
                   <label htmlFor={uniqueId}>
                       {properties.type === 'default' || properties.type === undefined ? (
                           <div style={{textAlign: 'center'}}>
                               <Button variant={buttonStyles.variant}
                                       size={"small"}
                                       endIcon={endIcon ? <IconCustom style={{fontSize: '18px'}} iconType={endIcon.iconType}>{endIcon.icon ? endIcon.icon : endIcon}</IconCustom> : false}
                                       startIcon={startIcon ? <IconCustom iconType={startIcon.iconType}
                                                                          style={{fontSize: '18px'}}
                                       >{startIcon.icon ? startIcon.icon : startIcon}</IconCustom> : false}
                                       component="span"
                                       disabled={isDisabled ? isDisabled : loadingData}
                                       color={isDisabled ? 'default' : isOldBackground ? buttonStyles.color : buttonStyles.background}
                                       style={btnStyles}
                               >{multiLanguageLabel}
                               </Button>
                               {errorMessage && (
                                   <Typography color={"secondary"} variant={"subtitle2"}>{errorMessage}</Typography>
                               )}
                           </div>
                       ) : (
                           <div>
                               <IconButton
                                   variant={styles.variant}
                                   component="span"
                                   disabled={isDisabled ? isDisabled : loadingData}
                                   color={isDefaultBackground ? buttonStyles.background : isOldBackground ? buttonStyles.color : ''}
                                   style={{
                                       width: styles.width,
                                       height: styles.height,
                                       margin: styles.margin,
                                       padding: styles.padding ? styles.padding : 3,
                                       textAlign: styles.textAlign,
                                       color: isDefaultBackground ? '' : buttonStyles.background
                                   }}
                               >
                                   <IconCustom iconType={properties.iconType} style={{fontSize: styles.fontSize || '18px'}}>
                                       {properties.icon}
                                   </IconCustom>
                               </IconButton>
                               {errorMessage && (
                                   <Typography color={"secondary"} variant={"subtitle2"}>{errorMessage}</Typography>
                               )}
                           </div>
                       )}

                   </label>
        </span>
        </Tooltip>
    )
};

function checkForActionType(type) {
    return type === 'updateEntity' || type === 'createEntity' || type === 'startProcess'
        || type === 'startTask' || type === 'completeTask' || type === 'deleteTask'
}